// EditFranchise.jsx — FINAL WORKING VERSION
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function EditFranchise() {
  const { id } = useParams();
  const navigate = useNavigate();


  const [form, setForm] = useState({
    franchise_type: "",
    franchise_brand: "",
    territory_name: "",
    territory_type: "",
    starter_clients_available: 0,
    starter_clients_count: "",
    starter_clients_total_value: "",
    starter_clients_avg_job_price: "",
    work_guarantee: 0,
    work_guarantee_amount: "",
    work_guarantee_period: "",
    contract_remaining: "",
    weekly_royalty: "",
    monthly_marketing_fee: "",
    training_included: 0,
    vehicle_included: 0,
    vehicle_details: "",
    trailer_included: 0,
    trailer_details: "",
    equipment_included: 0,
    equipment_details: "",
    price: "",
    description: "",
    suburb: "",
    state: "",
    postcode: "",
    enquiry_only: 0,
  });

  const [loading, setLoading] = useState(true);

  // Load franchise data
  useEffect(() => {
    async function loadFranchise() {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/lawn-mowing/franchises/${id}`);
        if (!res.data.success) {
          alert("Listing not found.");
          navigate("/my-listings");
          return;
        }

        const data = res.data.listing;

        // Convert nulls → empty strings
        const cleaned = Object.fromEntries(
          Object.entries(data).map(([key, value]) => [key, value ?? ""])
        );

        setForm(cleaned);
        setLoading(false);
      } catch (err) {
        console.error("LOAD ERROR:", err);
        alert("Error loading listing.");
      }
    }

    loadFranchise();
  }, [id, API_BASE_URL, navigate]);

  function updateField(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function saveChanges() {
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${API_BASE_URL}/api/lawn-mowing/franchises/edit/${id}`,
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert("Franchise updated successfully!");
      navigate("/my-listings");
    } catch (err) {
      console.error("SAVE ERROR:", err);
      alert("Error saving changes.");
    }
  }

  if (loading) return <p>Loading...</p>;

  // Shared input style
  const inputStyle = {
    padding: "10px",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "6px",
    marginBottom: "12px",
  };

  const sectionStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    marginBottom: "25px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
  };

  return (
    <div style={{ width: "90%", maxWidth: "900px", margin: "0 auto", paddingTop: "30px" }}>
      <h1 style={{ fontWeight: "800", color: "#2e7d32", marginBottom: "20px" }}>
        Edit Franchise Listing
      </h1>

      {/* SECTION — Franchise Info */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Franchise Info</h2>

        <label>Franchise Type</label>
        <select
          value={form.franchise_type}
          onChange={(e) => updateField("franchise_type", e.target.value)}
          style={inputStyle}
        >
          <option value="new">New</option>
          <option value="existing">Existing</option>
        </select>

        <label>Franchise Brand</label>
        <input
          type="text"
          value={form.franchise_brand}
          onChange={(e) => updateField("franchise_brand", e.target.value)}
          style={inputStyle}
        />

        <label>Territory Name</label>
        <input
          type="text"
          value={form.territory_name}
          onChange={(e) => updateField("territory_name", e.target.value)}
          style={inputStyle}
        />

        <label>Territory Type</label>
        <select
          value={form.territory_type}
          onChange={(e) => updateField("territory_type", e.target.value)}
          style={inputStyle}
        >
          <option value="exclusive">Exclusive</option>
          <option value="shared">Shared</option>
        </select>
      </div>

      {/* SECTION — Starter Clients */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Starter Clients</h2>

        <label>Starter Clients Available</label>
        <select
          value={form.starter_clients_available}
          onChange={(e) => updateField("starter_clients_available", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>

        {form.starter_clients_available == 1 && (
          <>
            <label>Starter Clients Count</label>
            <input
              type="number"
              value={form.starter_clients_count}
              onChange={(e) => updateField("starter_clients_count", e.target.value)}
              style={inputStyle}
            />

            <label>Total Client Value</label>
            <input
              type="number"
              value={form.starter_clients_total_value}
              onChange={(e) => updateField("starter_clients_total_value", e.target.value)}
              style={inputStyle}
            />

            <label>Average Job Price</label>
            <input
              type="number"
              value={form.starter_clients_avg_job_price}
              onChange={(e) => updateField("starter_clients_avg_job_price", e.target.value)}
              style={inputStyle}
            />
          </>
        )}
      </div>

      {/* SECTION — Work Guarantee */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Work Guarantee</h2>

        <label>Guarantee Included</label>
        <select
          value={form.work_guarantee}
          onChange={(e) => updateField("work_guarantee", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>

        {form.work_guarantee == 1 && (
          <>
            <label>Guarantee Amount</label>
            <input
              type="number"
              value={form.work_guarantee_amount}
              onChange={(e) => updateField("work_guarantee_amount", e.target.value)}
              style={inputStyle}
            />

            <label>Guarantee Period (months)</label>
            <input
              type="number"
              value={form.work_guarantee_period}
              onChange={(e) => updateField("work_guarantee_period", e.target.value)}
              style={inputStyle}
            />
          </>
        )}
      </div>

      {/* SECTION — Fees */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Fees</h2>

        <label>Contract Remaining (months)</label>
        <input
          type="number"
          value={form.contract_remaining}
          onChange={(e) => updateField("contract_remaining", e.target.value)}
          style={inputStyle}
        />

        <label>Weekly Royalty</label>
        <input
          type="number"
          value={form.weekly_royalty}
          onChange={(e) => updateField("weekly_royalty", e.target.value)}
          style={inputStyle}
        />

        <label>Monthly Marketing Fee</label>
        <input
          type="number"
          value={form.monthly_marketing_fee}
          onChange={(e) => updateField("monthly_marketing_fee", e.target.value)}
          style={inputStyle}
        />

        <label>Training Included</label>
        <select
          value={form.training_included}
          onChange={(e) => updateField("training_included", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>
      </div>

      {/* SECTION — Assets */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Assets Included</h2>

        <label>Vehicle Included</label>
        <select
          value={form.vehicle_included}
          onChange={(e) => updateField("vehicle_included", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>

        {form.vehicle_included == 1 && (
          <input
            type="text"
            placeholder="Vehicle Details"
            value={form.vehicle_details}
            onChange={(e) => updateField("vehicle_details", e.target.value)}
            style={inputStyle}
          />
        )}

        <label>Trailer Included</label>
        <select
          value={form.trailer_included}
          onChange={(e) => updateField("trailer_included", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>

        {form.trailer_included == 1 && (
          <input
            type="text"
            placeholder="Trailer Details"
            value={form.trailer_details}
            onChange={(e) => updateField("trailer_details", e.target.value)}
            style={inputStyle}
          />
        )}

        <label>Equipment Included</label>
        <select
          value={form.equipment_included}
          onChange={(e) => updateField("equipment_included", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>

        {form.equipment_included == 1 && (
          <input
            type="text"
            placeholder="Equipment Details"
            value={form.equipment_details}
            onChange={(e) => updateField("equipment_details", e.target.value)}
            style={inputStyle}
          />
        )}
      </div>

      {/* SECTION — Location */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Location</h2>

        <label>Suburb</label>
        <input
          type="text"
          value={form.suburb}
          onChange={(e) => updateField("suburb", e.target.value)}
          style={inputStyle}
        />

        <label>State</label>
        <input
          type="text"
          value={form.state}
          onChange={(e) => updateField("state", e.target.value)}
          style={inputStyle}
        />

        <label>Postcode</label>
        <input
          type="text"
          value={form.postcode}
          onChange={(e) => updateField("postcode", e.target.value)}
          style={inputStyle}
        />
      </div>

      {/* SECTION — Price + Description */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "15px" }}>Price & Description</h2>

        <label>Sale Price</label>
        <input
          type="number"
          value={form.price}
          onChange={(e) => updateField("price", e.target.value)}
          style={inputStyle}
        />

        <label>Description</label>
        <textarea
          value={form.description}
          onChange={(e) => updateField("description", e.target.value)}
          style={{ ...inputStyle, height: "120px" }}
        />
      </div>

      {/* Enquiry Only */}
      <div style={sectionStyle}>
        <label>Enquiry Only</label>
        <select
          value={form.enquiry_only}
          onChange={(e) => updateField("enquiry_only", Number(e.target.value))}
          style={inputStyle}
        >
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>
      </div>

      {/* Save Button */}
      <button
        onClick={saveChanges}
        style={{
          background: "#2e7d32",
          color: "white",
          padding: "14px 20px",
          width: "100%",
          borderRadius: "8px",
          border: "none",
          fontSize: "1.1rem",
          fontWeight: "700",
          cursor: "pointer",
          marginBottom: "40px",
        }}
      >
        Save Changes
      </button>
    </div>
  );
}
